/**
 * Core functions and utilities for TagadaPay Plugin SDK v2
 * Structured with utils (pure functions) and resources (API clients)
 */

// Export utilities (pure functions)
export * from './utils';

// Export resources (axios-based API clients)
export * from './resources';

// Export clients (stateful logic)
export * from './client';
export * from './funnelClient';

// Export path remapping helpers (framework-agnostic)
export * from './pathRemapping';

// Export legacy files that are still needed
export * from './googleAutocomplete';
export * from './isoData';
